import { sortBy } from 'lodash';

export default {
  getProductGroup: (state) => state.productGroup,
  getGroupById: (state) => (id) => state.productGroups.find((group) => group.id === id),
  productGroups: (state) => sortBy(state.productGroups, 'name'),
};
